import React, { useState } from "react";

const Booking = () => {
  const [step, setStep] = useState(1);
  const [selectedDay, setSelectedDay] = useState(7);

  const dateNames = ['SUNDAY', 'MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY'];
  const monthName = 'September';

  function getOrdinal(n) {
    let s = ["th", "st", "nd", "rd"],
      v = n % 100;
    return n + (s[(v - 20) % 10] || s[v] || s[0]);
  }

  const handleDayClick = (day) => {
    setSelectedDay(day);
  };

  const getDayName = (dayNum) => {
    const dayIndex = (1 + dayNum) % 7; // Sept 1st 2020 was Tuesday
    return dateNames[dayIndex];
  };

  const getDayString = (dayNum) => {
    return dayNum < 10 ? '0' + dayNum : dayNum;
  };

  const currentDayName = getDayName(selectedDay);
  const currentDayNumString = getDayString(selectedDay);
  const shortName = currentDayName.charAt(0) + currentDayName.slice(1).toLowerCase().substring(0, 2);
  const leftDateDisplay = `${shortName}, ${getOrdinal(selectedDay)} ${monthName}`;

  const renderCalendar = () => {
    const daysArr = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];
    const squares = [];
    
    // headers
    daysArr.forEach((d, idx) => {
      squares.push(<div key={`header-${idx}`} className="cal-header">{d}</div>);
    });

    // empty for Tuesday start
    squares.push(<div key="empty-1" className="cal-day empty"></div>);
    squares.push(<div key="empty-2" className="cal-day empty"></div>);

    for (let i = 1; i <= 30; i++) {
      squares.push(
        <div 
          key={`day-${i}`} 
          className={`cal-day ${selectedDay === i ? 'active' : ''}`}
          onClick={() => handleDayClick(i)}
        >
          {i}
        </div>
      );
    }
    return squares;
  };

  const handleNextStep = (nextStep) => {
    if (nextStep === 3) {
      const name = document.getElementById('fname')?.value?.trim();
      const email = document.getElementById('femail')?.value?.trim();
      if (!name || !email) {
        alert('Please enter your details to proceed.');
        return;
      }
    }
    setStep(nextStep);
  };

  return (
    <>
      <section className="inner-banner">
        <img src="/images/inner-banner.png" alt="" />
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12">
              <div className="inner-banner-text">
                <img src="/images/robort1.png" alt="" className="robort1" />
                <img src="/images/robort2.png" alt="" className="robort2" />
                <h1>Schedule <span>Demo</span></h1>
                <div className="store-links">
                  <a href="#"><img src="/images/app-img1.png" alt="App Store" /></a>
                  <a href="#"><img src="/images/app-img2.png" alt="Google Play" /></a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="booking-wrap">
        <img src="/images/booking-img.png" alt="" />
        <div className="container-fluid" id="booking-app">
          <div className="row signup-header">
            <div className="col-md-8" data-aos="zoom-in-right" data-aos-duration="1200">
              <p className="section-label"><span></span> Sign Up</p>
              <h2 className="signup-title"> <span>Schedule a</span> demo now</h2>
            </div>
            <div className="col-md-4" data-aos="zoom-in-left" data-aos-duration="1200">
              <p>Be the first to know when the app launches, and get early access to our referees, sporting directors and coaches.</p>
            </div>
          </div>
          
          <div className="row g-4 align-items-stretch">
            {/* LEFT PANEL */}
            <div className="col-md-6">
              <div className="panel h-100" id="left-panel">
                <div className="brand-logo">
                  Rem
                  <svg className="logo-ball" width="22" height="22" viewBox="0 0 24 24" fill="none">
                    <circle cx="12" cy="12" r="10" fill="#00D084" />
                    <path d="M12 2L14 8L20 9L15 13L16 19L12 16L8 19L9 13L4 9L10 8L12 2Z" fill="#1e1e1e" opacity="0.6" />
                  </svg>
                  te <span className="logo-ref">Ref</span>
                </div>

                <h2 className="fw-bold text-white mt-4 mb-2 meeting-title">30 Minute Meeting</h2>
                <div className="d-flex align-items-center text-muted mb-2 duration-text">
                  <i className="fa-regular fa-clock me-2"></i> 30 min
                </div>

                <div 
                  id="left-date-display" 
                  className="text-white mt-1 left-date-text"
                  style={{ display: step > 1 ? 'block' : 'block' }}
                >
                  {leftDateDisplay}
                </div>

                <div className="illus-container">
                  <img src="/images/booking-illustration.png" alt="" />
                  <video loop autoPlay muted src="/images/onboarding.mp4"></video>
                </div>
              </div>
            </div>

            {/* RIGHT PANEL */}
            <div className="col-md-6">
              <div className="panel h-100" id="right-panel">
                
                {/* STEP 1 */}
                <div className={`step-panel ${step === 1 ? 'active' : ''}`} id="step1">
                  <div className="d-flex justify-content-between align-items-center mb-1">
                    <h5 className="m-0 text-white fw-semibold step-title">Select a Date & Time</h5>
                    <button className="btn-light-custom" onClick={() => handleNextStep(2)}>Next</button>
                  </div>
                  <div className="d-flex align-items-center text-muted mb-2 duration-text">
                    <i className="fa-regular fa-clock me-2"></i> 30 min
                  </div>

                  <div className="cal-wrapper">
                    <div className="cal-left">
                      <div id="display-day-name" className="fw-bold mb-1 day-name-display">{currentDayName}</div>
                      <div className="text-white mb-1 month-name-display">{monthName}</div>
                      <div id="display-day-num" className="fw-bold text-white lh-1 mt-1 day-num-display">{currentDayNumString}</div>
                    </div>
                    <div className="cal-right" id="calendar">
                      {renderCalendar()}
                    </div>
                  </div>
                </div>

                {/* STEP 2 */}
                <div className={`step-panel ${step === 2 ? 'active' : ''}`} id="step2">
                  <h5 className="text-white mb-4 fw-semibold step-title">Fill The Form Below:</h5>
                  <form className="booking-form flex-grow-1 d-flex flex-column h-100" onSubmit={(e) => { e.preventDefault(); handleNextStep(3); }}>
                    <div className="mb-3">
                      <input type="text" className="form-control" placeholder="Name" id="fname" required />
                    </div>
                    <div className="mb-3">
                      <input type="email" className="form-control" placeholder="Email" id="femail" required />
                    </div>
                    <div className="mb-3">
                      <input type="tel" className="form-control" placeholder="Phone" id="fphone" required />
                    </div>
                    <div className="d-flex justify-content-end pb-1 pt-3">
                      <button type="submit" className="btn-light-custom">Submit</button>
                    </div>
                  </form>
                </div>

                {/* STEP 3 */}
                <div className={`step-panel ${step === 3 ? 'active' : ''}`} id="step3">
                  <div className="d-flex flex-column justify-content-center align-items-center h-100 w-100 pb-4">
                    <div className="mb-4">
                      <img src="/images/robort1.png" alt="" />
                    </div>
                    <h3>Done</h3>
                    <p>The details had been sent to your inbox.</p>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Booking;
